import { type CreatePageRequest, type Page, ProjectRole } from "../../types";
import { generateId } from "../../utils";
import { defaultCanvasSettings } from "./editor-store-helpers";
import type { PageSliceState } from "./page-slice-types";

export function buildPage(
  pageData: CreatePageRequest,
  state: PageSliceState,
): Page {
  const now = new Date();

  return {
    id: generateId("page"),
    projectId: state.project?.id || "",
    name: pageData.name,
    description: pageData.description,
    order: pageData.order ?? state.pages.length,
    isDefault: state.pages.length === 0,
    template: pageData.template,
    navigation: {
      showInNavigation: true,
      allowNavigation: true,
      requiresAuth: false,
      order: pageData.order ?? state.pages.length,
      ...pageData.navigation,
    },
    permissions: {
      canView: [
        ProjectRole.OWNER,
        ProjectRole.ADMIN,
        ProjectRole.EDITOR,
        ProjectRole.VIEWER,
      ],
      canEdit: [ProjectRole.OWNER, ProjectRole.ADMIN, ProjectRole.EDITOR],
      canDelete: [ProjectRole.OWNER, ProjectRole.ADMIN],
      canShare: [ProjectRole.OWNER, ProjectRole.ADMIN],
      inheritFromProject: true,
      customPermissions: [],
      ...pageData.permissions,
    },
    canvasSettings: { ...defaultCanvasSettings },
    metadata: {
      viewCount: 0,
      editCount: 0,
      componentCount: 0,
      tags: [],
      customFields: {},
    },
    createdBy: state.project?.ownerId || "",
    lastModifiedBy: state.project?.ownerId || "",
    lastModifiedAt: now,
    createdAt: now,
    updatedAt: now,
  };
}
